"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTooltipXAxisValue = exports.calculateRegressionLine = exports.formatIndicatorValue = exports.getXAxisTickFormat = exports.yAxisTickFormat = void 0;
var chartUtils_1 = require("../chartUtils");
exports.yAxisTickFormat = function (d) { return chartUtils_1.formatLinearNumbers(d); };
exports.getXAxisTickFormat = function (width, chartBreakPoints, ticks) {
    if (width <= chartBreakPoints.medium[0] &&
        width > chartBreakPoints.small[0] &&
        ticks.length > 2) {
        return function (d, i) { return (i % 2 === 0 ? chartUtils_1.formatLinearNumbers(d) : ''); };
    }
    return function (d) { return chartUtils_1.formatLinearNumbers(d); };
};
exports.formatIndicatorValue = function (value) {
    return chartUtils_1.formatLinearNumbers(value);
};
exports.calculateRegressionLine = function (slope, intercept, minX, maxX) {
    return [
        { x: minX, y: minX * slope + intercept },
        { x: maxX, y: maxX * slope + intercept },
    ];
};
exports.formatTooltipXAxisValue = function (value) {
    return chartUtils_1.formatLinearNumbers(value);
};
